<template>
  <Row id="OvertimeApplication">
    <Col :span="24" class="title">
      <TypographyTitle>{{$t('nav.name.OvertimeApplicationManage')}}</TypographyTitle>
    </Col>
    <Col :span="24" class="content">
      <Row :gutter="[16,32]">
        <Col :span="24" >
          <Form :model="searchForm">
            <Row :gutter="30">
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('overtimeApplication.name.search')" name="search">
                  <Input :placeholder="$t('overtimeApplication.name.search')" v-model:value="searchForm.search"></Input>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('attendance.name.dateRange')" name="dateRange">
                  <RangePicker :allowClear="false" v-model:value="rangePickerDate" @change="rangeChange"/>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('attendance.name.department')" name="department">
                      <!--关联表的下拉选择-->
                      <Select
                              v-model:value="searchForm.idDep"
                      >
                      <SelectOption :value="null">{{ $t('attendance.name.select_all') }}</SelectOption>
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['departmentList']" :value="item['idDep']">{{ item['name'] }}</SelectOption>
                      </Select>
                </FormItem>
              </Col>
              <Col span="10">
                    <FormItem :label="$t('leave.field.status')" name="status">
                      <Select
                              v-model:value="searchForm.status"
                              :placeholder="$t('leave.validate.required.status')"
                              :dropdownStyle="{ zIndex: 9999999950 }"
                      >
                      <SelectOption :value="null">{{ $t('attendance.name.select_all') }}</SelectOption>
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['statusList']" :value="item['value']">{{ item['label'] }}</SelectOption>
                      </Select>
                  </FormItem>
                </Col>
              <!-- <Col :xs="24" :sm="8">
                <FormItem :label="$t('public.field.status')">
                  <Select v-model:value="searchForm.status" :placeholder="$t('public.placeholder.please_select')">
                    <SelectOption :value="0">{{ $t('public.placeholder.please_select') }}</SelectOption>
                    <SelectOption :value="1">{{ $t('public.status.1') }}</SelectOption>
                    <SelectOption :value="2">{{ $t('public.status.2') }}</SelectOption>
                  </Select>
                </FormItem>
              </Col> -->
              <Col :xs="24" :sm="8" class="text-right">
                <Button type="primary" @click="search_submit">{{$t('public.name.search')}}</Button>&nbsp;
                <Button @click="search_reset">{{$t('public.name.reset')}}</Button>&nbsp;
                <Button type="primary" @click="exportXml">{{$t('public.name.export')}}</Button>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col :span="24">
        <Table :columns="columns" :dataSource="list" :scroll="{ x: true }" rowKey="idOveApp" :loading="loading" :pagination="tablePagination" @change="chang_page">
            <template #actionTitle>
              <span>
                {{$t("public.table.action")}}
                <Button v-if="checkPermission('OvertimeApplicationManage.Add')" type="primary" size="small" shape="circle" @click="add()">
                  <PlusOutlined />
                </Button>
              </span>
            </template>
            <template #action="{text}">
              <div>
                <!-- <div class="pc-display">
                  <Button type="default" size="small" @click="detail(text)">{{$t("public.name.detail")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('OvertimeApplicationManage.Edit') && !record.approverId" type="primary" size="small" @click="edit(text)">{{$t("public.name.edit")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('OvertimeApplicationManage.Delete')" type="primary" danger size="small" @click="del(text.idOveApp)">{{$t("public.name.del")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('OvertimeApplicationManage.Approve') && !record.approverId" type="primary" size="small" @click="approve(text)">{{$t("overtimeApplication.name.approve")}}</Button>
                </div> -->
                <Dropdown :trigger="['click']">
                  <template #overlay>
                    <Menu>
                      <MenuItem @click="detail(text)">{{$t('public.name.detail')}}</MenuItem>
                      <MenuItem v-if="checkPermission('OvertimeApplicationManage.Edit')" @click="edit(text)">{{$t('public.name.edit')}}</MenuItem>
                      <MenuItem v-if="checkPermission('OvertimeApplicationManage.Delete')" danger @click="del(text.idOveApp)">{{$t('public.name.del')}}</MenuItem>
                      <!-- <MenuItem v-if="checkPermission('OvertimeApplicationManage.Approve') && !record.approverId" danger @click="approve(text)">{{$t("overtimeApplication.name.approve")}}</MenuItem> -->
                    </Menu>
                  </template>
                  <Button size="small">
                    {{$t("public.name.more")}}
                    <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
            </template>
          </Table>
        </Col>
      </Row>
    </Col>
    <OvertimeApplicationDetail ref="refOvertimeApplicationDetail"></OvertimeApplicationDetail>
    <OvertimeApplicationEdit ref="refOvertimeApplicationEdit" @updateList="get_list"></OvertimeApplicationEdit>
    <OvertimeApplicationApprove ref="refOvertimeApplicationApprove" @updateList="get_list"></OvertimeApplicationApprove>
  </Row>
</template>

<script>
import { createVNode } from "vue";
import { Row, Col, Table, Typography, Tag, Button, Dropdown, Menu, Modal, Form, Input, Select, message, RangePicker } from "ant-design-vue";
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { OvertimeApplicationList } from "@/api/OvertimeApplicationList";
import { OvertimeApplicationDelete } from "@/api/OvertimeApplicationDelete"
import { DepartmentListAll } from "@/api/DepartmentListAll";
import { OvertimeApplicationExport } from "@/api/OvertimeApplicationExport";
import OvertimeApplicationDetail from "@/components/Home/OvertimeApplicationDetail";
import OvertimeApplicationEdit from "@/components/Home/OvertimeApplicationEdit";
import OvertimeApplicationApprove from "@/components/Home/OvertimeApplicationApprove";
import moment from "moment";

export default {
  name: "OvertimeApplicationManage",
  components: {
    Row,
    Col,
    Table,
    Form,
    FormItem: Form.Item,
    TypographyTitle: Typography.Title,
    Tag,
    Button,
    Input,
    Select,
    SelectOption: Select.Option,
    Dropdown,
    DownOutlined,
    PlusOutlined,
    ExclamationCircleOutlined,
    Menu,
    MenuItem: Menu.Item,
    OvertimeApplicationDetail,
    OvertimeApplicationEdit,
    OvertimeApplicationApprove,
    RangePicker,
  },
  data() {
    return {
      rangePickerDate:[null,null],
      searchForm: {
        search: '',
        idDep: null,
        startDate: null,
        endDate: null,
        status: null,
      },
      tablePagination: {
        pageSizeOptions: ["10", "20", "50", "100"],
        showSizeChanger: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
      list: [],
      columns: [
          { title: this.$t("overtimeApplication.table.id_ove_app"), fixed: "left", dataIndex: "idOveApp", key: "idOveApp" },
          { title: this.$t("overtimeApplication.table.id_emp"), dataIndex: "employeeNickName", key: "employeeNickName" },
          { title: this.$t("overtimeApplication.table.start_time"), dataIndex: "startTime", key: "startTime", customRender: ({text}) =>{return moment(text).format('YYYY-MM-DD')}},
          // { title: this.$t("overtimeApplication.table.end_time"), dataIndex: "endTime", key: "endTime", customRender: ({text}) =>{return moment(text).format('YYYY-MM-DD')}},
          { title: this.$t("overtimeApplication.table.duration"), dataIndex: "duration", key: "duration", customRender: ({text,record}) =>{
              // var days =  Math.floor(text/480);
              // var hours =  Math.floor(text%480/60);
              // var minutes =  text%60;
              // var result = '';
              // if(days !== 0){
              //   result = days + '天';
              // }
              // if(hours !== 0){
              //   result = result + hours + "小時"
              // }
              // if(minutes !== 0){
              //   result = result + minutes + "分鐘"
              // }
              // return result;
              return text + "小時"
            }
          },
          { title: this.$t("overtimeApplication.table.status"), dataIndex: "status", key: "status", customRender: ({text,record}) =>{
              return this.selectList.statusList.find(item=>item.value===text).label
            }
          },
          { title: this.$t("overtimeApplication.table.approver_id"), dataIndex: "approverNickName", key: "approverNickName" },
          { title: this.$t("overtimeApplication.table.approve_time"), dataIndex: "approveTime", key: "approveTime" },
          { title: this.$t("overtimeApplication.table.reason"), dataIndex: "reason", key: "reason" },
        { title: this.$t("overtimeApplication.table.submit_time"), dataIndex: "submitTime", key: "submitTime", customRender: ({text}) =>{return moment(text).format('YYYY-MM-DD HH:mm:ss')}},
//           { title: this.$t("overtimeApplication.table.time_frame"), dataIndex: "timeFrame", key: "timeFrame", customRender: ({text}) =>{
//               if(text){
// return this.selectList.timeFrameList.find(item=>item.value===text).label
//               }
              
//             }
//           },
          // { title: this.$t("overtimeApplication.table.time_unit"), dataIndex: "timeUnit", key: "timeUnit", customRender: ({text}) =>{
          //     return this.selectList.timeUnitList.find(item=>item.value===text).label
          //   }
          // },
          // { title: this.$t("overtimeApplication.table.status"), dataIndex: "status", key: "status", customRender: ({text}) =>{
          //     return this.selectList.statusList.find(item=>item.value===text).label
          //   }
          // },
          { title: this.$t("overtimeApplication.table.reject_reason"), dataIndex: "rejectReason", key: "rejectReason" },
          { title: this.$t("overtimeApplication.table.approver2_id"), dataIndex: "approver2NickName", key: "approver2NickName" },
          { title: this.$t("overtimeApplication.table.approver2_time"), dataIndex: "approver2Time", key: "approver2Time" },
          { title: this.$t("overtimeApplication.table.time_remark"), dataIndex: "timeRemark", key: "timeRemark" },
        { key: "action", fixed: "right", slots: { title: "actionTitle", customRender: "action" } },
      ],
      selectList:{
        employeeList: [],
        departmentList: [],
        timeFrameList: [{value: 1,label: 'AM'},{value: 2,label: 'PM'}],
        timeUnitList: [{value: 0.25,label: '0.25'},{value: 0.50,label: '0.50'},{value: 1.00,label: '1.00'}],
        statusList: [{value: 0,label: '待發送'},{value: 1,label: '待審批'},{value: 2,label: '已拒絕'},{value: 3,label: '已通過'}],
      }
    };
  },
  methods: {
    chang_page(pagination) {
      this.tablePagination = pagination;
      this.get_list();
    },
    get_list() {
      this.loading = true;
      const api = new OvertimeApplicationList();
      const getData = {
        page: this.tablePagination.current,
        limit: this.tablePagination.pageSize,
      }
      if (this.searchForm.search != "") getData.search = this.searchForm.search
      if (this.searchForm.idDep != 0) getData.idDep = this.searchForm.idDep
      if (this.searchForm.startDate != "") getData.startDate = this.searchForm.startDate
      if (this.searchForm.endDate != "") getData.endDate = this.searchForm.endDate
      getData.status = this.searchForm.status
      api
        .get(getData)
        .then((response) => {
          this.loading = false;
          if (0 === parseInt(response.data.code)) {
            const dataTmp = response.data.data;
            this.tablePagination.current = parseInt(dataTmp.current);
            this.tablePagination.pageSize = parseInt(dataTmp.pageSize);
            this.tablePagination.total = parseInt(dataTmp.total);
            this.list = dataTmp.data;
            //如果當前處於不是第一頁，但是又沒有數據的情況，則把頁面設置為1，並重新請求
            if(this.list.length == 0 && this.tablePagination.current != 1){
              this.tablePagination.current = 1;
              this.get_list();
            }
          } else {
            this.list = [];
          }
        });
    },
    rangeChange(dates){
      this.searchForm.startDate = dates[0].format("YYYY-MM-DD")
      this.searchForm.endDate = dates[1].format("YYYY-MM-DD")
    },
    add() {
      this.$refs.refOvertimeApplicationEdit.addShow();
    },
    detail(obj) {
      this.$refs.refOvertimeApplicationDetail.detailShow(obj);
    },
    approve(obj) {
      this.$refs.refOvertimeApplicationApprove.detailShow(obj);
    },
    edit(obj) {
      this.$refs.refOvertimeApplicationEdit.editShow(obj);
    },
    del(idOveApp) {
      Modal.confirm({
        title: this.$t("public.name.are_you_sure_delete") + "?",
        content: this.$t("public.name.action_cannot_resumed"),
        icon: createVNode(ExclamationCircleOutlined),
        okText: this.$t("public.name.yes"),
        okType: "danger",
        cancelText: this.$t("public.name.no"),
        onOk: () => {
          const api = new OvertimeApplicationDelete();
          api.post({ idOveApp: idOveApp }).then((response) => {
            if (0 === parseInt(response.data.code)) {
              this.get_list();
              message.success(response.data.msg);
            } else {
              message.error(response.data.msg);
            }
          });
        },
      });
    },
    getDepartmentList() {
      const api = new DepartmentListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
          this.selectList.departmentList = response.data.data;
        } else {
          message.error(response.data.msg);
        }
      });
    },
    exportXml() {
      const api = new OvertimeApplicationExport();
      const getData = {
      }
      if (this.searchForm.search != "") getData.search = this.searchForm.search
      if (this.searchForm.idDep != 0) getData.idDep = this.searchForm.idDep
      if (this.searchForm.startDate != "") getData.startDate = this.searchForm.startDate
      if (this.searchForm.endDate != "") getData.endDate = this.searchForm.endDate
      getData.status = this.searchForm.status
      api
        .download(getData)
        .then((response) => {
          // console.log(decodeURI(res.headers['filename']));
          let blob = new Blob([response.data], { type: "application/xlsx" });
          let url = window.URL.createObjectURL(blob);
          const link = document.createElement("a"); // 创建a标签
          link.href = url;
          link.download = decodeURI(response.headers['filename']); // 重命名文件
          link.click();
          URL.revokeObjectURL(url);
        });
    },
    search_submit() {
      this.get_list()
    },
    search_reset() {
      this.rangePickerDate = [null,null];
      this.searchForm = {
        search: '',
        idDep: null,
        startDate: null,
        endDate: null,
        status: null,
      };
      this.get_list()
    }
  },
  mounted() {
    this.get_list();
    this.getDepartmentList();
  },
}
</script>

<style lang="less">
@import url("~@/assets/less/home/overtimeApplication.less");
</style>